import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { untypedIsEnabled } from '@ip-only/client-features';
import {
  getCurrentPortalCommunicationOperator,
  isGlobalConnect,
  PortalCommunicationOperator,
} from '../utils/communication-operator.util';

@Injectable({
  providedIn: 'root',
})
export class InitGoogleAnalyticsService {
  public start(): Promise<void> {
    if (isGlobalConnect() && untypedIsEnabled('cookieBotGoogleAnalytics')) {
      const currentOperator = getCurrentPortalCommunicationOperator();
      const tagId =
        currentOperator === PortalCommunicationOperator.GlobalConnectFi
          ? environment.globalConnectFi.googleTagManagerId
          : environment.globalConnectSe.googleTagManagerId;

      this.injectGtagScripts(tagId, this.getGtmPreviewParams());
    }
    return Promise.resolve();
  }

  private getGtmPreviewParams(): string {
    try {
      const params = new URLSearchParams(window.location.search);
      const gtmAuth = params.get('gtm_auth');
      const gtmPreview = params.get('gtm_preview');

      if (!gtmAuth || !gtmPreview) {
        return '';
      }

      const gtmCookiesWin = params.get('gtm_cookies_win') ?? 'x';
      return `&gtm_auth=${encodeURIComponent(
        gtmAuth
      )}&gtm_preview=${encodeURIComponent(
        gtmPreview
      )}&gtm_cookies_win=${encodeURIComponent(gtmCookiesWin)}`;
    } catch {
      return '';
    }
  }

  /**
   * GTM magically handles Cookiebot
   * @param tagId GTM Id
   */
  private injectGtagScripts(tagId: string, params: string): void {
    /* Push event for GTM */

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    /* Add GTM script to head */

    const s: HTMLScriptElement = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${tagId}${params}`;
    const head: HTMLHeadElement = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  }
}
